class NostoSearch {
    constructor() {
        this.productList = document.querySelector('.collection__main').querySelector('.product-list');

        if (!this.productList) {
            this.removeSkeletons();
            console.error('Product list element not found');
            return;
        }

        this.currentPage = 0;
        this.productsPerPage = parseInt(this.productList.parentElement.dataset.productsPerPage, 10) || 16;
        this.api = null;
        this.searchCount = 0;

        this.init();
    }

    init() {
        window.onload = async () => {
            try {
                // Toujours configurer l'écouteur de filtres pour gérer les changements
                this.setupFilter();

                const urlParams = new URLSearchParams(window.location.search);
                const hasFilter = Array.from(urlParams.keys()).some(key => key.startsWith('filter'));
                const hasSortBy = urlParams.has('sort_by');

                // Si des filtres ou un tri sont appliqués, utiliser le système natif Shopify
                if (hasFilter || hasSortBy) {
                    this.showFallbackContent();
                } else {
                    await this.initializeNosto();
                    this.setupPagination();
                    this.setupSorting();

                    // Masquer la pagination Shopify native quand Nosto est actif
                    const shopifyPagination = document.querySelector('.shopify-pagination');
                    if (shopifyPagination) {
                        shopifyPagination.classList.add('hidden');
                    }
                }
            } catch (error) {
                console.error('Error initializing Nosto search:', error);
            }
        };
    }

    removeSkeletons() {
        document.querySelectorAll('.skeleton').forEach(skeleton => skeleton.remove());
    }

    updateURLParameter(key, value) {
        const url = new URL(window.location);
        url.searchParams.set(key, value);
        window.history.pushState({}, '', url);
    }

    getURLParameter(name) {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(name);
    }

    async checkElement (selector) {
        while (document.querySelector(selector) === null) {
            await new Promise(resolve => requestAnimationFrame(resolve))
        }
        return document.querySelector(selector);
    }

    getCachedData(key) {
        const cachedData = sessionStorage.getItem(key);
        if (!cachedData) {
            return null;
        }
        const { data, timestamp } = JSON.parse(cachedData);
        const now = new Date().getTime();
        // set 1 hour caching for performance purposes
        if (now - timestamp > 3600000) { 
            sessionStorage.removeItem(key);
            return null;
        }
        return data;
    }

    setCachedData(key, data) {
        const timestamp = new Date().getTime();
        sessionStorage.setItem(key, JSON.stringify({ data, timestamp }));
    }

    async fetchUrls(query, size, from) {
        try {
            const response = await this.api.search({
                query: query,
                products: {
                    fields: ['url'],
                    facets: ['*'],
                    size: size,
                    from: from
                }
            },
            {
                redirect: true,
                track: 'serp',
                isKeyword: true
            });



            const result = response || [];

            if (!result.products) {
                throw new Error('No products returned from Nosto API');
            }

            const urls = result.products?.hits?.map(product => product.url) || [];

            const handles = urls.map(url => {
                const parts = url.split('/');
                return parts[parts.length - 1];
            });

            const totalResults = result.products.total || 0;
            const totalPages = Math.ceil(totalResults / size);
            const currentPage = Math.floor(from / size) + 1;
            return {
                handles: handles.join(','),
                currentPage: currentPage,
                totalPages: totalPages,
                totalResults: totalResults,
            };

        } catch (error) {            
            
            this.showFallbackContent();
            console.error('Error fetching URLs from Nosto API:', error);
            return {
                handles: '',
                currentPage: 0,
                totalPages: 0,
                totalResults: 0,
            };
        }
    }


    async loadProducts(page) {
        document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));

        const searchParams = new URLSearchParams(window.location.search);
        const searchQuery = searchParams.get('q');
        const cacheKey = `nostoProductHandlesPage${page}_PerPage${this.productsPerPage}_query:${searchQuery}`;
        let handlesParameter = this.getCachedData(cacheKey);
        let paginationData;

        if (!handlesParameter) {
            try {
                    paginationData = await this.fetchUrls(searchQuery, this.productsPerPage, (page - 1) * this.productsPerPage);
                    handlesParameter = paginationData.handles;
                    this.totalPages = paginationData.totalPages;
                    if (!handlesParameter) {
                        console.error('Nosto: No handles to fetch');
                        this.showFallbackContent();
                        return false;
                    }
                this.setCachedData(cacheKey, handlesParameter);
            } catch (error) {
                console.error('Error fetching URLs:', error);
                return false;
            }
        } else {
            paginationData = await this.fetchUrls(searchQuery, this.productsPerPage, (page - 1) * this.productsPerPage);
            this.totalPages = paginationData.totalPages;
            if(handlesParameter !== paginationData.handles){
                handlesParameter = paginationData.handles;
            }
        }

        
        const handlesArray = handlesParameter.split(',');
        const handlesLength = handlesArray.length;
        const ElmCount = document.querySelector(".search-result-count");

        const str = ElmCount.textContent.replace(/^\d+/, '');
        

        if (ElmCount) {
            ElmCount.classList.remove('hidden')
            ElmCount.innerHTML = paginationData.totalResults + str;
            document.title = paginationData.totalResults + str;
        }

        document.querySelector('#pagination-nosto').innerHTML = this.renderPagination(page, this.totalPages);

        try {
            // Si pas de handles mais totalResults est 0, c'est normal (aucun résultat)
            if (!handlesParameter || handlesParameter === '') {
                if (paginationData.totalResults === 0) {
                    // Aucun résultat, afficher la liste vide
                    this.productList.closest("#main")?.classList.add('nosto-loaded');
                    this.productList.innerHTML = '';
                    this.productList.style.opacity = 1;
                    document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
                    return true;
                } else {
                    // Erreur : pas de handles mais des résultats attendus
                    console.error('Error: No handles but totalResults > 0');
                    document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
                    return false;
                }
            }
            
            const urls = handlesParameter;
            const resultArray = urls.split(',');
            function isEmptyProductCard(cardHtml) {
                const parser = new DOMParser();
                const doc = parser.parseFromString(cardHtml?.["product-card"], 'text/html');
                const productCard = doc.querySelector('product-card');
                if (!productCard) return true; 
                const dataProductId = productCard.getAttribute('data-product-id');
                return !dataProductId;
              }
            if(resultArray[0] !== ""){
                const promises = resultArray.map((url) => fetch(`${window.Shopify.routes.root}products/${url}?sections=product-card`).then(res => res.json()));

                Promise.all(promises).then((res) => {

                // Filtrer le tableau pour supprimer les produits vides
                const filteredProductCards = res.filter(
                    (product) => !isEmptyProductCard(product)
                  );

                const combinedHTML = filteredProductCards.map(r => r['product-card'].replace(/^<div.*?class="shopify-section[^>]*?>/, "").replace(/<\/div>$/, "")).join("");
                this.productList.closest("#main")?.classList.add('nosto-loaded');
                this.productList.innerHTML = combinedHTML;
                this.productList.style.opacity = 1

                this.checkElement('product-card[reveal-on-scroll="true"]').then(() => {
                    const productCards = this.productList.querySelectorAll('product-card[reveal-on-scroll="true"]');
                    if(productCards) {
                        productCards.forEach(card => card.setAttribute('is-nosto-product', ''));
                        this.revealCards(productCards);
                    }
                    
                    productCards.forEach(card => {
                        const anchor =  card.querySelector('a[data-instant]');
                        const url = window.location.origin + anchor.getAttribute('href');
                        card.addEventListener('click', (event) => {
                            setTimeout( () => {
                                nostojs(api => {
                                    api.recordSearchClick('serp', {
                                        productId: card.dataset.productId,
                                        url: url,
                                    });
                                });
                            },200)
                         });
                       });
                });


                });
                document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
                return true;

            } else {
                // Cas où resultArray[0] est vide - aucun produit à afficher
                this.productList.closest("#main").classList.add('nosto-loaded');
                this.productList.innerHTML = '';
                this.productList.style.opacity = 1;
                document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
                return true;
            }
        } catch (error) {
            console.error('Error during section render fetch:', error);
            return false;
        }
    }

    revealCards(elements) {
        elements.forEach((element, index) => {
            setTimeout(() => {
                if (index === 0) {
                    document.dispatchEvent(new Event('collection-rendred'));
                  }
                element.classList.add('visible');
            }, index * 50 + 400);
        });
    }

    setupFilter() {
        // Utiliser une fonction fléchée pour préserver le contexte 'this'
        const handleFacetUpdate = (event) => {
            // Attendre que le système natif ait terminé sa mise à jour AJAX
            setTimeout(() => {
                // AUB-574: Refresh stale productList reference after AJAX DOM replacement
                const fresh = document.querySelector('.collection__main .product-list');
                if (fresh) this.productList = fresh;

                const url = new URL(window.location.href);
                const params = new URLSearchParams(url.search);
                const hasFilter = Array.from(params.keys()).some(key => key.startsWith('filter'));
                const hasSortBy = params.has('sort_by');

                // Si des filtres ou un tri sont appliqués, désactiver Nosto et utiliser le système natif
                if (hasFilter || hasSortBy) {
                    this.showFallbackContent();
                    // Réinitialiser la pagination Nosto si elle existe
                    const paginationContainer = document.querySelector('#pagination-nosto');
                    if (paginationContainer) {
                        paginationContainer.innerHTML = '';
                    }
                } else {
                    // Si aucun filtre, réactiver Nosto si l'API est disponible
                    // Masquer la pagination Shopify native
                    const shopifyPagination = document.querySelector('.shopify-pagination');
                    if (shopifyPagination) {
                        shopifyPagination.classList.add('hidden');
                    }

                    if (this.api) {
                        this.currentPage = 1;
                        this.loadProducts(this.currentPage);
                    } else {
                        // Si Nosto n'était pas initialisé, l'initialiser maintenant
                        this.initializeNosto().then(() => {
                            this.setupPagination();
                            this.setupSorting();
                        });
                    }
                }

                // Mettre à jour le compteur de résultats
                const searchCount = document.querySelector(".search-result-count");
                if(searchCount) {
                    searchCount.classList.remove('hidden');
                    document.title = searchCount.innerHTML;
                }

            }, 100);
};

        // Ajouter l'écouteur une seule fois
        if (!this._facetUpdateListenerAdded) {
document.addEventListener("facet:update", handleFacetUpdate);
            this._facetUpdateListenerAdded = true;
        }
    }

    setupSorting() {
        localStorage.setItem("clear_sort", false);
        if (localStorage.getItem("clear_sort") === "false") {
            const sortOptions = document.querySelectorAll('.popover-listbox__option group');
            if (!sortOptions)
                return;
            sortOptions?.forEach(function (opt) {
                if (opt.checked) opt.removeAttribute('checked');
            });
            if (location.href.includes('?sort_by')) {
                history.pushState({}, null, location.href.split('?')[0]);
            }
            localStorage.setItem("clear_sort", true);
        }
    }

    setupPagination() {
        let paginationContainer = document.querySelector('#pagination-nosto');
        if (!paginationContainer) {
            paginationContainer = document.createElement('div');
            paginationContainer.id = 'pagination-nosto';
            this.productList.parentElement.appendChild(paginationContainer);
        }
    
        this.currentPage = this.getURLParameter('page') ? parseInt(this.getURLParameter('page'), 10) : 1;
        this.currentPage = isNaN(this.currentPage) || this.currentPage < 1 ? 1 : this.currentPage;
    
        const totalPages = this.totalPages || 1;
    
        this.renderPagination(this.currentPage, totalPages);
    
        paginationContainer.addEventListener('click', async (event) => {
            if (event.target.tagName === 'A') {
                event.preventDefault();
    
                const page = parseInt(event.target.getAttribute('data-page'), 10);
                if (page && page !== this.currentPage) {
                    this.currentPage = page;
                    this.productList.style.opacity = 0.4;
    
                    const success = await this.loadProducts(this.currentPage);
                    if (success) {
                        this.updateURLParameter('page', this.currentPage);
                        this.renderPagination(this.currentPage, totalPages);
                        document.querySelector(".collection").scrollIntoView({ block: "start", behavior: "smooth" });
                    }
                }
            }
        });
    }

    renderPagination(currentPage, totalPages) {
        let paginationHtml = '';
    
        if (totalPages <= 1) return paginationHtml; 

        const rightArrowSvg = `
        <svg aria-hidden="true" focusable="false" fill="none" width="11" class="icon icon-chevron-right  icon--direction-aware" viewBox="0 0 10 10">
            <path d="m3 9 4-4-4-4" stroke="currentColor" stroke-linecap="square"></path>
        </svg>`;

         const leftArrowSvg = `
        <svg aria-hidden="true" focusable="false" fill="none" width="11" class="icon icon-chevron-left  icon--direction-aware" viewBox="0 0 10 10">
            <path d="m7 9-4-4 4-4" stroke="currentColor" stroke-linecap="square"></path>
        </svg>`;
    
        if (currentPage > 1) {
            paginationHtml += `<a href="#" data-page="${currentPage - 1}" class="pagination__link h6 pagination-prev">${leftArrowSvg}</a>`;
        }
    
        const range = 2;
        let startPage, endPage;
    
        if (totalPages <= 2 * range + 1) {
            startPage = 1;
            endPage = totalPages;
        } else {
            if (currentPage <= range) {
                startPage = 1;
                endPage = range * 2 + 1;
            } else if (currentPage + range >= totalPages) {
                startPage = totalPages - range * 2;
                endPage = totalPages;
            } else {
                startPage = currentPage - range;
                endPage = currentPage + range;
            }
        }
    
        if (startPage > 1) {
            paginationHtml += `<a href="#" data-page="1" class="pagination__link h6 pagination-page">1</a>`;
            if (startPage > 2) paginationHtml += `<a href="#" class="pagination__link h6 pagination__ellipsis">...</a>`;
        }
    
        for (let i = startPage; i <= endPage; i++) {
            paginationHtml += `<a href="#" data-page="${i}" ${i === currentPage ? 'aria-current="page"' : ''} class="pagination__link h6 pagination-page ${i === currentPage ? 'pagination__link--disabled' : ''}">${i}</a>`;
        }
    
        if (endPage < totalPages) {
            if (endPage < totalPages - 1) paginationHtml += `<a href="#" class="pagination__link h6 pagination__ellipsis">...</a>`;
            paginationHtml += `<a href="#" data-page="${totalPages}" class="pagination__link h6 pagination-page">${totalPages}</a>`;
        }
    
        if (currentPage < totalPages) {
            paginationHtml += `<a href="#" data-page="${currentPage + 1}" class="pagination__link h6 pagination-next">${rightArrowSvg}</a>`;
        }
    
        return paginationHtml;
    }

    async initializeNosto() {
        const timeoutPromise = new Promise((_, reject) =>
            setTimeout(() => reject(new Error('Nosto API timeout after 5s')), 5000)
        );

        const nostoPromise = new Promise((resolve, reject) => {
            nostojs(async nostoApi => {
                try {
                    console.info('Nosto API initialized');
                    this.api = nostoApi;
                    this.api.loadRecommendations();

                    const pageParam = this.getURLParameter('page');
                    if (pageParam) {
                        this.currentPage = parseInt(pageParam, 10);
                    } else {
                        this.currentPage = isNaN(this.currentPage) || this.currentPage < 1 ? 1 : this.currentPage;
                    }

                    const success = await this.loadProducts(this.currentPage);
                    if (!success) {
                        this.currentPage = 1;
                        await this.loadProducts(this.currentPage);
                    }
                    resolve();
                } catch (err) {
                    reject(err);
                }
            });
        });

        try {
            await Promise.race([nostoPromise, timeoutPromise]);
        } catch (error) {
            console.error('Error initializing Nosto API:', error);
            this.showFallbackContent();
        }
    }

    showFallbackContent() {
        this.removeSkeletons();

        this.productList.closest("#main").classList.add('nosto-fallback');
        this.productList.style.opacity = 1;

        // Afficher la pagination Shopify native et masquer la pagination Nosto
        const shopifyPagination = document.querySelector('.shopify-pagination');
        const nostoPagination = document.querySelector('#pagination-nosto');

        if (shopifyPagination) {
            shopifyPagination.classList.remove('hidden');
        }
        if (nostoPagination) {
            nostoPagination.innerHTML = '';
        }
    }
}

new NostoSearch('product-list');
